module.exports = __webpack_public_path__ + "static/media/20_anos.6176a03d.webp";